/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum WeeklyTimeUnit {
  Hourly = "Hourly",
  Daily = "Daily",
}

export const WeeklyTimeUnitDisplay: Record<WeeklyTimeUnit, string> = {
  [WeeklyTimeUnit.Hourly]: "Hourly",
  [WeeklyTimeUnit.Daily]: "Daily",
};
